const getQuery = (params) => {
  let query = ''

  Object.keys(params).forEach((key) => {
    if (params[key] || params[key] === 0) {
      if (query) {
        query += `&${key}=${params[key]}`
      }
      else {
        query += `?${key}=${params[key]}`
      }
    }
  })

  return query
}


export default getQuery
